import { Injectable } from '@angular/core';
import { UrlService } from '@uirouter/core';

/**
 * handles all json manipulation like deep copying and parsing.
 * Some built in methods are not the most efficient way so these
 * methods offer alternatives.
 */
@Injectable({
  providedIn: 'root'
})
export class JsonService {
  constructor(
    private urlService: UrlService
  ) {}

  // Creates a copy of an object
  copy ( obj = {} ) : any {
    return JSON.parse(JSON.stringify(obj));
  }

  // takes all the query parameters and parses them into a json object
  getQueryParameters () : any {
    let paramSearch: string;

    /**
     * parent.window throws when embedded in a cross-origin iframe;
     * fall back to the current frame's URL in that case.
     */
    try {
      paramSearch = parent.window.location.search;
    }
    catch {
      paramSearch = window.location.search;
    }

    const params      = new URLSearchParams(paramSearch);
    const queryParams = this.urlService.search();

    const paramObj = {};

    for ( const key of params.keys() ) {
      paramObj[ key ] = decodeURIComponent(params.get(key));
    }

    for ( const key in queryParams ) {
      paramObj[ key ] = decodeURIComponent(queryParams[key]);
    }

    return this.copy(paramObj);
  }

  parse ( json : any ) : any {
    try {
      return JSON.parse(json);
    }
    catch (exception) {
      return json;
    }
  }

  stripEmpties ( items : Array<any>, join ?: string ) : Array<any> | string {
    const strippedItems = items.filter(Boolean);

    return join
      ? strippedItems.join(join)
      : strippedItems;
  }
}